$(document).ready(function() {
  if ($('.food-waste.prr-site-content').length) {
  // Open accordion item with class "initial-open" on page load
  $('.accordion-item.initial-open .collapse').collapse('show')
  $('.accordion-item.initial-open').addClass('open');
  $('.accordion-item.initial-open').next('.accordion-item').addClass('next-to-open');

    $('.accordion-item').on('show.bs.collapse', function () {
      $(this).addClass('open');
      $(this).next('.accordion-item').addClass('next-to-open');
    });

  $('.accordion-item').on('hide.bs.collapse', function () {
    $(this).removeClass('open');
    $(this).next('.accordion-item').removeClass('next-to-open');
  });
  }
});